export const sdcActionsConstant = {
  ADD_FILTERS: 'ADD_FILTERS',
  ADD_LOCKED_FILTERS: 'ADD_LOCKED_FILTERS',
  ADD_PENDING_SAVE: 'ADD_PENDING_SAVE',
  ADD_STUDENT_SUPPORTS: 'ADD_STUDENT_SUPPORTS',
  APPEND_COLUMN_DATA: 'APPEND_COLUMN_DATA',
  CLEAR_ALL_UNLOCKED_FILTERS: 'CLEAR_ALL_UNLOCKED_FILTERS',
  CLEAR_FILTER_FOR_COLUMN: 'CLEAR_FILTER_FOR_COLUMN',
  MULTI_STUDENT_PATCH: 'MULTI_STUDENT_PATCH',
  MULTI_STUDENT_UPDATE: 'MULTI_STUDENT_UPDATE',
  REFETCH_COLUMNS_THAT_DEPEND_ON_ASYNC: 'REFETCH_COLUMNS_THAT_DEPEND_ON_ASYNC',
  REMOVE_PENDING_SAVE: 'REMOVE_PENDING_SAVE',
  SELECT_ALL_STUDENTS: 'SELECT_ALL_STUDENTS',
  SELECT_FILTERED_STUDENTS: 'SELECT_FILTERED_STUDENTS',
  SET_CURRENT_SDC_STATE: 'SET_CURRENT_SDC_STATE',
  SET_ENTIRE_FILTER: 'SET_ENTIRE_FILTER',
  SET_FILTER_FOR_COLUMN: 'SET_FILTER_FOR_COLUMN',
  SET_LOCKED_FILTERS: 'SET_LOCKED_FILTERS',
  SET_RECENT_EDITED_STUDENT_IDS: 'SET_RECENT_EDITED_STUDENT_IDS',
  SET_SDC_ACTIVITY: 'SET_SDC_ACTIVITY',
  SET_SELECTED_STUDENT_IDS: 'SET_SELECTED_STUDENT_IDS',
  SET_SORT: 'SET_SORT',
  SET_STUDENTS_COLUMN_KEYS_SCHOOL_SORT_AND_FILTER: 'SET_STUDENTS_COLUMN_KEYS_SCHOOL_SORT_AND_FILTER',
  UNLOCK_ALL_FILTERS: 'UNLOCK_ALL_FILTERS',
  UNSELECT_ALL_STUDENTS: 'UNSELECT_ALL_STUDENTS',
  UPDATE_SCHOOL_BY_PATCH: 'UPDATE_SCHOOL_BY_PATCH',
  UPDATE_STUDENT_FIELD_BY_PATH: 'UPDATE_STUDENT_FIELD_BY_PATH',
  UPDATE_STUDENT_SUPPORTS: 'UPDATE_STUDENT_SUPPORTS',
  UPDATE_UI_STATE: 'UPDATE_UI_STATE',
  RESET_FLATTENED_STUDENTS: 'RESET_FLATTENED_STUDENTS',
  RESET_CURRENT_SDC_STATE: 'RESET_CURRENT_SDC_STATE',
  MERGE_USER_ADDED_COLUMNS: 'MERGE_USER_ADDED_COLUMNS',
  ADD_COURSE_DIFFS: 'ADD_COURSE_DIFFS',
  ADD_GAP_PLANS: 'ADD_GAP_PLANS',
  UPDATE_COURSE_DIFF: 'UPDATE_COURSE_DIFF',
  UPDATE_GAP_PLAN: 'UPDATE_GAP_PLAN',
  SET_ALL_SCHOOL_USERS: 'SET_ALL_SCHOOL_USERS',
  ADD_SCHOOL_SUPPORT: 'ADD_SCHOOL_SUPPORT',
  UPDATE_SCHOOL_SUPPORT: 'UPDATE_SCHOOL_SUPPORT',
  SET_ALL_SCHOOL_SUPPORTS: 'SET_ALL_SCHOOL_SUPPORTS',
  SET_ALL_STUDENT_SUPPORTS: 'SET_ALL_STUDENT_SUPPORTS',
  SET_ALL_STUDENTS: 'SET_ALL_STUDENTS',
};
